// ErrorBoundary.tsx — حاجز أخطاء React علويّ. يلتقط أيّ استثناء غير مُلتقَط أثناء الـrender في أيّ
// مكان بالشجرة (مثلاً pedigree_html تالف) ويعرض رسالة قابلة للتعافي بدل شاشة بيضاء فارغة. يجب أن
// يكون class component: React لا يوفّر بديل hooks لـ getDerivedStateFromError/componentDidCatch.
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Button } from './ui/button';
import i18n from '../lib/i18n';

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('Unhandled render error caught by ErrorBoundary:', error, info.componentStack);
	}

	handleReload = () => {
		window.location.reload();
	};

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex items-center justify-center" style={{ minHeight: '100vh' }}>
					<div className="flex max-w-sm flex-col items-center gap-3 text-center">
						<IconAlertTriangle size={48} opacity={0.5} />
						<h1 className="text-lg font-bold">{i18n.t('errorBoundary.title', 'حدث خطأ غير متوقّع')}</h1>
						<p className="text-muted-foreground">
							{i18n.t('errorBoundary.description', 'واجه التطبيق خطأً أثناء عرض هذه الصفحة. حاول إعادة تحميل الصفحة.')}
						</p>
						<Button onClick={this.handleReload}>{i18n.t('errorBoundary.reload', 'إعادة تحميل الصفحة')}</Button>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}
